export default "__VITE_ASSET__APFCYBJy__"